<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  setting: { type: Object, required: true },
});

const emit = defineEmits(['edit', 'delete', 'toggle']);

const { t } = useI18n();

const statusColor = computed(() => {
  return props.setting.active ? 'text-g-400 bg-g-50' : 'text-n-slate-11 bg-n-slate-3';
});

const statusLabel = computed(() => {
  return props.setting.active
    ? t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.STATUS.ACTIVE')
    : t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.STATUS.INACTIVE');
});

const inboxName = computed(() => {
  return props.setting.inbox?.name || t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.DEFAULT_INBOX');
});
</script>

<template>
  <div
    class="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 p-4 border border-n-weak rounded-lg bg-n-alpha-2"
  >
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2">
        <h4 class="text-sm font-medium text-n-slate-12 truncate">
          {{ setting.form_name || setting.form_id }}
        </h4>
        <span
          class="text-xs font-medium px-2 py-0.5 rounded-full"
          :class="statusColor"
        >
          {{ statusLabel }}
        </span>
      </div>
      <div class="flex flex-wrap items-center gap-3 text-xs text-n-slate-11 mt-1">
        <span class="font-mono bg-n-slate-3 px-1.5 py-0.5 rounded text-n-slate-12">
          {{ t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.FORM_ID') }}: {{ setting.form_id }}
        </span>
        <span class="font-mono bg-n-slate-3 px-1.5 py-0.5 rounded text-n-slate-12">
          {{ t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.ADVERTISER_ID') }}: {{ setting.advertiser_id }}
        </span>
      </div>
      <div class="flex items-center gap-2 mt-2 text-xs text-b-600">
        <i class="i-lucide-inbox text-sm" />
        <span class="font-medium">
          {{ t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.DESTINATION_INBOX') }}:
        </span>
        <span class="text-n-slate-12 font-medium bg-b-50 px-2 py-0.5 rounded-md border border-b-100">
          {{ inboxName }}
        </span>
      </div>
    </div>
    <div class="flex items-center gap-2 flex-shrink-0">
      <Button
        xs
        faded
        slate
        :label="t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.ACTIONS.EDIT')"
        icon="i-lucide-pencil"
        @click="emit('edit', setting)"
      />
      <Button
        xs
        faded
        ruby
        :label="t('INTEGRATION_SETTINGS.TIKTOK_LEAD_ADS.ACTIONS.DELETE')"
        icon="i-lucide-trash"
        @click="emit('delete', setting)"
      />
    </div>
  </div>
</template>
